import { logInfo } from 'apps/promo/helpers/clientLogger';
/* eslint-disable indent */
const TRY_COUNTER = __isDev__ ? 0 : 5;

type DataLayerEvent = {
    event?: string;
    parameters?: Record<string, unknown>;
    [key: string]: unknown;
};
type DataLayer = Array<DataLayerEvent> & { push: (event: DataLayerEvent) => number };
type GtEventParams = Record<string, unknown>;

declare global {
    interface Window {
        dataLayer?: DataLayer;
    }
}

declare const dataLayer: DataLayer | undefined;

export const initTagManagerOnce = (containerId?: string): void => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    const id = containerId ?? process.env.GOOGLE_TAG_MANAGER_ID;
    if (!id) return;

    // prevent duplicate loading
    if ((window as unknown as { google_tag_manager?: unknown }).google_tag_manager) {
        return;
    }
    const layer: DataLayer = window.dataLayer ?? ([] as unknown as DataLayer);
    window.dataLayer = layer;
    layer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });
    const script = document.createElement('script');
    const firstScript = document.getElementsByTagName('script')[0];
    script.async = true;
    // GTG initialization:
    script.src = `/metrics/?id=${id}`;
    firstScript?.parentNode?.insertBefore(script, firstScript);
};

export const sendGtEvent = (value: string, params?: GtEventParams): void => {
    let timerId: ReturnType<typeof setInterval> | null = null;
    let counter = 1;
    if (typeof dataLayer !== 'undefined') {
        pushGtEvent(value, params);
    } else {
        timerId = setInterval(() => pushGtEvent(value, params, counter++, timerId), 700);
    }
};

const pushGtEvent = (value: string, params?: GtEventParams, counter = 0, timerId: ReturnType<typeof setInterval> | null = null): void => {
    if (typeof dataLayer !== 'undefined') {
        const event: DataLayerEvent = { event: value };
        if (params) {
            event.parameters = params;
        }
        dataLayer.push(event);
        if (__isDev__) {
            logInfo('GT event', event);
        }
        if (timerId) {
            clearInterval(timerId);
        }
    } else if (counter >= TRY_COUNTER && timerId) {
        clearInterval(timerId);
    }
};

export const getLibreFAQParam = (questionId: number): string | null => {
    switch (questionId) {
        case 289:
            return 'how_accept';
        case 291:
            return 'how_spend';
        case 292:
            return 'how_secure';
        case 293:
            return 'paysend_card';
        case 294:
            return 'how_get_card';
        case 295:
            return 'is_card_free';
        case 296:
            return 'is_card_card secure';
        default:
            return null;
    }
};
